import { render, staticRenderFns } from "./saveAsPlan.vue?vue&type=template&id=498cea1a"
import script from "./saveAsPlan.vue?vue&type=script&lang=js"
export * from "./saveAsPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports